<img [src]="card.cardPath" alt="{{ card.cardName }}" (click)="onCardClick()" />
